import { useState, useEffect, useMemo, useRef } from 'react';
import { FeatureGroup } from 'react-leaflet';
import { EditControl } from 'react-leaflet-draw';
import L from 'leaflet';

function EditableLayer({
    data,
    map,
    onChange,
    showDrawControl,
    isHideEditControl,
    layer,
    onLayerClicked,
}) {
    const editLayerRef = useRef();
    let drawControlRef = useRef();

    useEffect(() => {
        if (!showDrawControl) {
            map?.removeControl(drawControlRef.current);
        } else {
            map?.addControl(drawControlRef.current);
        }

        editLayerRef.current.clearLayers();
        editLayerRef.current.addLayer(layer);
        layer.on('click', function (e) {
            onLayerClicked(e, drawControlRef.current);
        });
    }, [editLayerRef, map, showDrawControl, onLayerClicked, layer]);

    const _onMounted = ctl => {
        drawControlRef.current = ctl;
    };

    const _onEdited = e => {
        let layers = e.layers.toGeoJSON();
        let editFeatures = data.features.map((feature, index) => {
            layers.features.forEach((layer, index) => {
                if (
                    layer.properties.editLayerId ===
                    feature.properties.editLayerId
                ) {
                    feature = {
                        ...feature,
                        geometry: {
                            ...feature.geometry,
                            coordinates:
                                layers.features[index].geometry.coordinates,
                        },
                    };
                }
            });
            return feature;
        });
        onChange({ type: 'FeatureCollection', features: editFeatures });
    };

    // const _onCreated = e => {
    // let type = e.layerType;
    // let layer = e.layer;
    // if (type === 'marker') {
    //     // Do marker specific actions
    //     console.log('_onCreated: marker created', e);
    // } else {
    //     console.log('_onCreated: something else created:', type, e);
    // }
    // onChange();
    // };

    const _onDeleted = e => {
        let layers = e.layers.toGeoJSON();
        let editFeatures = [];
        data.features.forEach((feature, index) => {
            layers.features.forEach((layer, index) => {
                if (
                    layer.properties.editLayerId !==
                    feature.properties.editLayerId
                ) {
                    editFeatures.push(feature);
                }
            });
            return feature;
        });
        onChange({ type: 'FeatureCollection', features: editFeatures });
    };

    return (
        <div>
            <FeatureGroup ref={editLayerRef}>
                <EditControl
                    position="topright"
                    onMounted={_onMounted}
                    onEdited={_onEdited}
                    // onCreated={_onCreated}
                    onDeleted={_onDeleted}
                    draw={{
                        polyline: !isHideEditControl && {
                            icon: new L.DivIcon({
                                iconSize: new L.Point(8, 8),
                                className:
                                    'leaflet-div-icon leaflet-editing-icon',
                            }),
                            shapeOptions: {
                                guidelineDistance: 10,
                                color: 'navy',
                                weight: 3,
                            },
                        },
                        marker: false,
                        rectangle: false,
                        circlemarker: false,
                        circle: false,
                        polygon: false,
                    }}
                />
            </FeatureGroup>
        </div>
    );
}

export default function EditableGroup({ map, data, onChange }) {
    const [selectedLayerIndex, setSelectedLayerIndex] = useState(0);
    function handleLayerClick(e, drawControl) {
        setSelectedLayerIndex(e.target.feature.properties.editLayerId);
    }
    let dataLayer = new L.GeoJSON(data);
    let layers = [];
    let i = 0;
    dataLayer.eachLayer(layer => {
        layer.feature.properties.editLayerId = i;
        layers.push(layer);
        i++;
    });

    const isHideEditControl = useMemo(() => data?.features?.length > 0, [data]);

    return (
        <div>
            {layers.map((layer, i) => {
                return (
                    <EditableLayer
                        key={i}
                        layer={layer}
                        showDrawControl={i === selectedLayerIndex}
                        onLayerClicked={handleLayerClick}
                        map={map}
                        data={data}
                        isHideEditControl={isHideEditControl}
                        onChange={onChange}
                    />
                );
            })}
        </div>
    );
}
